/* Realitní pohled jednoho klienta — jediné místo, kde na něj frontend sahá.
 *
 * PROČ ADAPTÉR: kontrakt s backendem je na jednom místě. Když se routa
 * přejmenuje, mění se tenhle soubor, ne karta ve složce.
 *
 * ⚠️ SELHÁNÍ SE NEPŘEVÁDÍ NA PRÁZDNO. „Klient nemá žádnou nemovitost" a
 * „nepodařilo se to načíst" jsou dvě různé věty. Kdyby chyba tiše vracela
 * prázdné seznamy, makléř by ve složce prodávajícího neviděl jeho zakázku,
 * založil by ji znovu a měl v systému dva záznamy o jednom bytě.
 */
import api from "@/lib/api";

/** Vždy pole objektů — ne-pole ani null nesmí projít dál jako data. */
const pole = (v) => (Array.isArray(v) ? v.filter((x) => x && typeof x === "object") : []);

/**
 * Všechno realitní k jednomu klientovi.
 * @returns {{prodej: Array, koupe: Array, predavky: Array, hypoteky: Array,
 *            poradceJmeno: string, odmenaHypotekaNastavena: boolean,
 *            odmenaObchodNastavena: boolean}}
 */
export async function nactiRealityKlienta(contactId, jazyk = "cs") {
  const { data } = await api.get(`/api/reality-klient/${contactId}`, { params: { jazyk } });
  /* Odpověď bez jediného očekávaného pole není prázdný klient — je to jiná
     odpověď, než jakou čekáme (proxy, přesměrování na login, změněná routa). */
  if (!data || typeof data !== "object" || !Array.isArray(data.prodej)) {
    throw new Error("neocekavana-odpoved");
  }
  return {
    prodej: pole(data.prodej),
    koupe: pole(data.koupe),
    predavky: pole(data.predavky),
    hypoteky: pole(data.hypoteky),
    poradceJmeno: typeof data.poradce_jmeno === "string" ? data.poradce_jmeno : "",
    odmenaHypotekaNastavena: data.odmena_hypoteka_nastavena === true,
    odmenaObchodNastavena: data.odmena_obchod_nastavena === true,
  };
}

/** Má klient vůbec něco realitního? Rozhoduje o tom, jestli se karta kreslí. */
export function maReality(prehled) {
  if (!prehled) return false;
  return (prehled.prodej?.length || 0) > 0
    || (prehled.koupe?.length || 0) > 0
    || (prehled.predavky?.length || 0) > 0;
}

/** Jsou tohle realitní obchody? Karta se kreslí místo běžného řádku obchodu. */
export const REALITNI_TYPY = ["prodej_nemovitosti", "koupe_nemovitosti"];
export const jeRealitni = (productType) => REALITNI_TYPY.includes(productType);
